import script from "./BalanceRecords.vue?vue&type=script&setup=true&lang=js"
export * from "./BalanceRecords.vue?vue&type=script&setup=true&lang=js"

import "./BalanceRecords.vue?vue&type=style&index=0&id=bd2aafca&scoped=true&lang=css"

import exportComponent from "/www/wwwroot/pet/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bd2aafca"]])

export default __exports__